
import { defineComponent, computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import StarXpGate from '@/components/star/StarXpGate.vue'
import StarTabBar from '@/components/star/StarTabBar.vue'

export default defineComponent({
  name: 'StarQuant',
  components: { StarXpGate, StarTabBar },
  setup() {
    const route = useRoute()
    const activeTab = ref('quant')

    const iframeUrl = computed(() => {
      const isTest = location.hostname.includes('test') || location.hostname.includes('localhost')
      const base = isTest
        ? 'https://test-h5.techgp.cn/jfzt-pc-frontend/index.html#/textRoom'
        : 'https://h5.9fh5.com/jfzt-pc-frontend/index.html#/textRoom'

      const params = new URLSearchParams({
        r: 'R11005844',
        platform: 'htz',
        teacherNo: '',
        userType: (route.query.userType as string) || '2',
        starInvest: 'true',
        freeRoom: '100',
        star: '1',
        roomNo: 'R11005844'
      })

      // 透传路由参数
      const { token, softNameAbbr, reffer, theme, userName } = route.query
      if (token) params.set('token', token as string)
      if (softNameAbbr) params.set('softNameAbbr', softNameAbbr as string)
      if (reffer) params.set('reffer', reffer as string)
      if (theme) params.set('theme', theme as string)
      if (userName) params.set('userName', userName as string)

      return `${base}?${params.toString()}`
    })

    return { activeTab, iframeUrl }
  }
})
